<template>
  <div>
    <el-table :data="userList" size="mini" height="calc(100vh - 353px)" :row-class-name="tableRowClassName">
      <el-table-column label="用户账户" fixed="left" min-width="200">
        <template slot-scope="scope">{{ scope.row.accountName }}</template>
      </el-table-column>

      <!-- <el-table-column prop="userType" label="用户身份">
        <template slot-scope="scope">
          <span v-if="scope.row.userType == '普通用户'" class="red">{{
            scope.row.userType
          }}</span>
          <span v-else class="cc">{{ scope.row.userType }}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="userId" label="用户UID" align="center" fixed="left" min-width="160">
        <template slot-scope="scope">
          <span @click="showBox(scope.row, 2)" :class="{
            tdRed: scope.row.mark == true,
            blue: scope.row.mark != true,
            myTd: true,
          }">{{ scope.row.userId }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="userTypeName" label="用户类型" align="center" min-width="120" />

      <el-table-column prop="channelUserId" label="合伙人UID" align="center" min-width="160">
        <template slot-scope="scope">
          <span @click="showBox(scope.row, 1)" class="myTd blue">{{
            scope.row.channelUserId
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rechargeAmount" label="总入金" align="center" />
      <el-table-column prop="txAmount" label="总出金" align="center" />
      <el-table-column prop="recharge" label="总净入金" align="center" />
      <el-table-column prop="profit" label="总盈亏" align="center" />
      <el-table-column prop="totalFee" label="总手续费" align="center" />
      <el-table-column prop="totalFundingFee" label="总资金费(USDT)" align="center" min-width="140">
        <template slot-scope="scope">
          {{ formatAmount(scope.row.totalFundingFee) }}
        </template>
      </el-table-column>

      <el-table-column prop="highCountFee" label="高频手续费" align="center" width="100" />
      <el-table-column prop="shortLineFee" label="超短线手续费" align="center" width="100" />
      <el-table-column prop="profitAmount" label="总净盈亏" align="center" />
      <el-table-column prop="deductedNetProfit" label="抵扣后总净盈亏(USDT)" align="center" min-width="170">
        <template slot-scope="scope">
          {{ formatAmount(scope.row.deductedNetProfit) }}
        </template>
      </el-table-column>
      <el-table-column prop="experienceDeductFee" label="体验金抵扣手续费(USDT)" align="center" min-width="180">
        <template slot-scope="scope">
          {{ formatAmount(scope.row.experienceDeductFee) }}
        </template>
      </el-table-column>
      <el-table-column prop="experiencePnlDeduct" label="体验金抵扣盈亏(USDT)" align="center" min-width="180">
        <template slot-scope="scope">
          {{ formatAmount(scope.row.experiencePnlDeduct) }}
        </template>
      </el-table-column>
      <el-table-column prop="experienceFundingFeeDeduct" label="体验金抵扣资金费(USDT)" align="center" min-width="190">
        <template slot-scope="scope">
          {{ formatAmount(scope.row.experienceFundingFeeDeduct) }}
        </template>
      </el-table-column>
      <el-table-column prop="feeCouponDeduct" label="手续费抵扣券抵扣金额(USDT)" align="center" min-width="210" />
      <el-table-column prop="pnlCouponDeduct" label="盈亏抵扣券抵扣金额(USDT)" align="center" min-width="210" />
      <!-- <el-table-column prop="spotBalance" label="现货余额" align="center" /> -->
      <el-table-column prop="contractBalance" label="合约总资产" align="center" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.contractBalance }}
        </template>
      </el-table-column>
      <el-table-column prop="experienceBalance" label="体验金余额" align="center" min-width="150" />
      <el-table-column prop="feeDeductBalance" label="手续费抵扣券余额" align="center" min-width="170" />
      <el-table-column prop="pnlDeductBalance" label="盈亏抵扣券余额" align="center" min-width="170" />
      <el-table-column prop="superBalance" label="超级合约资产" align="center" width="120" />
      <el-table-column prop="balance" label="法币总资产" align="center" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.otcBalance }}
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="冻结余额" align="center" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.coinFroze }}
        </template>
      </el-table-column>
      <el-table-column prop="positionExperienceProfit" label="仓位体验券盈利(USDT)" align="center" min-width="180" />
      <!-- <el-table-column label="注册时间">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column> -->
      <el-table-column label="备注" align="right" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column  label="是否展示备注">
        <template slot-scope="scope">
          <span v-if="scope.row">{{ scope.row.type}}</span>
        </template>
      </el-table-column> -->

      <!-- <el-button type="text" size="mini" @click="goDetail(scope.row)">资产明细</el-button> -->
      <!-- <el-table-column label="操作" align="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleUpdate(scope.row)"
            v-if="scope.row.type === 0"
            >修改备注</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pag">
      <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged">
      </pagination>
    </div>
    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <el-dialog :visible.sync="centerDialogVisible" width="30%" center>
      <div slot="title" class="dialog_title">
        <span>修改备注</span>
        <img :src="cha" alt="" @click="centerDialogVisible = false" />
      </div>
      <div class="main">
        <div class="title">备注信息</div>
        <div class="content">
          <el-input type="textarea" :rows="5" placeholder="请输入备注信息" maxlength="50" show-word-limit v-model="textarea2">
          </el-input>
        </div>
        <div class="btn">
          <el-button size="mini" type="primary" @click="add">添 加</el-button>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <UserDetailDialog :id="userId" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import UserDetailDialog from 'components/userDetailDialog'
import updateDialog from '../updatedialog'
import cha from '@/assets/partnerCenter/cha.png'
export default {
  name: 'UserList',
  data() {
    return {
      cha,
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: '',
      type: '',
      userId: '',
    }
  },
  components: {
    Pagination,
    updateDialog,
    UserDetailDialog,
  },
  methods: {
    ...mapActions('contractassets', ['addRemark']),
    ...mapMutations('contractassets', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
      'setUserDetailInfoVisible',
    ]),
    formatAmount(value) {
      return value === null || value === undefined || value === '' ? '--' : value
    },
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    handleUpdate(row) {
      this.updateForm = row
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true
      this.textarea2 = row.remark
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remark: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
            ; (this.textarea2 = ''), (this.centerDialogVisible = false)
          this.$emit('refresh')
        }
      })
    },
    goDetail(row) {
      this.$router.push({ path: `/home/contractAssets/detail`, query: row })
    },
    showBox(row, type) {
      this.type = type
      this.userId = type == 2 ? row.userId : row.channelUserId
      this.setUserDetailInfoVisible(true)
    },
    tableRowClassName({ row }) {
      if (row.mark == true) {
        return 'redRow'
      }
      return ''
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(['userInfo']),
    ...mapState('contractassets', [
      'pagination',
      'userList',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
    ]),
  },
}
</script>

<style lang="less" src="../../../../../styles/table.less" scoped>
// .pag{
//   display: flex;
//   justify-content: center;
// }
// .user-type-select {
//   width: 100%;
// }
// .red {
//   color: skyblue;
//   font-weight: bold;
// }
// .cc {
//   color: #97a0ff;
//   font-weight: bold;
// }
// ::v-deep .el-dialog__title {
//   color: #6767b3;
//   font-size: 24px;
// }
// ::v-deep.el-dialog__headerbtn {
//   font-size: 26px;
// }
// ::v-deep .el-dialog__body {
//   display: flex;
//   justify-content: center;
//   .main {
//     width: 100%;
//     position: relative;
//     .box-card {
//       width: 100%;
//       height: 260px;
//       .el-card__body {
//         height: 86%;
//         display: flex;
//         flex-direction: column;
//         justify-content: space-between;
//         .el-textarea{
//           box-shadow: 0px 0px 1px rgba(24, 26, 32, 0.1), 0px 3px 6px rgba(71, 77, 87, 0.04), 0px 1px 2px rgba(24, 26, 32, 0.04);
//         }
//         .el-textarea__inner{
//           padding: 18px 16px;
//         }
//         .btn{
//           display: flex;
//           justify-content: center;
//            .el-button--primary{
//       width: 156px;
//       height: 37px;
//       background: #707AFF;
//       border-radius: 4px;
//     }
//         }
//       }
//     }
//   }
// }
// ::v-deep .el-dialog--center {
//   margin-top: 5vh;
//   width: 468px;
//   // height: 557px;
//   background: #f5f6ff;
//   border-radius: 8px;
// }
::v-deep.el-table th {
  font-weight: bold;
  color: #909399;
}
</style>

<style lang="less" scoped>
.search {
  display: flex;
  gap: 20px;
}
</style>
